import { apiClient as apiClient } from "@/services/client";
import { AxiosResponse } from "axios";
import { CrewMember } from "@/models/CrewMember";
import { UserDocumentsResponse } from "@/models/UserDocuments";

const baseUrl = "/crew/list";

// Crew List
export const getCrewList = (): Promise<AxiosResponse<CrewMember[]>> => {
  return apiClient.get(`${baseUrl}`);
};

export const createCrewList = (crewListName: string) => {
  return apiClient.post(`${baseUrl}`, { listName: crewListName });
};

export const getCrewListById = (listId: string): Promise<AxiosResponse<CrewMember[]>> => {
  return apiClient.get(`${baseUrl}/${listId}`);
};

export const createCrewMember = ( listId: string, payload: Partial<CrewMember> ): Promise<AxiosResponse<CrewMember>> => {
  return apiClient.post(`${baseUrl}/${listId}`, payload);
};

export const deleteCrewListById = (listId: string): Promise<AxiosResponse<CrewMember[]>> => {
  return apiClient.delete(`${baseUrl}/${listId}`);
};

export const updateCrewListById = (listId: string, payload: any): Promise<AxiosResponse> => {
  return apiClient.put(`${baseUrl}/${listId}`, payload);
};

// Crew List Members
export const getCrewMember = (listId: string, crewId: string): Promise<AxiosResponse<CrewMember>> => {
  return apiClient.get(`${baseUrl}/${listId}/${crewId}`);
};

export const updateCrewMember = (listId: string, crewId: string, payload: Partial<CrewMember>): Promise<AxiosResponse<CrewMember>> => {
  return apiClient.put(`${baseUrl}/${listId}/${crewId}`, payload);
};

export const deleteCrewMember = (listId: string, crewId: string): Promise<AxiosResponse> => {
  return apiClient.delete(`${baseUrl}/${listId}/${crewId}`);
};

// Crew Member Passport
export const getPassportDocuments = (listId: string, crewId: string): Promise<AxiosResponse<UserDocumentsResponse>> => {
  return apiClient.get(`${baseUrl}/${listId}/${crewId}/passport`);
};

export const updatePassportDocuments = (listId: string, crewId: string, payload: UserDocumentsResponse): Promise<AxiosResponse<UserDocumentsResponse>> => {
  return apiClient.put(`${baseUrl}/${listId}/${crewId}/passport`, payload);
};

export const deletePassportDocument = (listId: string, crewId: string, uuid: string): Promise<AxiosResponse> => {
  return apiClient.delete(`${baseUrl}/${listId}/${crewId}/passport/${uuid}`);
};

// Crew Member License
export const getLicenseDocuments = (listId: string, crewId: string): Promise<AxiosResponse<UserDocumentsResponse>> => {
  return apiClient.get(`${baseUrl}/${listId}/${crewId}/license`);
};

export const updateLicenseDocuments = (listId: string, crewId: string, payload: UserDocumentsResponse): Promise<AxiosResponse<UserDocumentsResponse>> => {
  return apiClient.put(`${baseUrl}/${listId}/${crewId}/license`, payload);
};

export const deleteLicenseDocument = (listId: string, crewId: string, uuid: string): Promise<AxiosResponse> => {
  return apiClient.delete(`${baseUrl}/${listId}/${crewId}/license/${uuid}`);
};

// Crew Member VHF License
export const getVhfDocuments = (listId: string, crewId: string): Promise<AxiosResponse<UserDocumentsResponse>> => {
  return apiClient.get(`${baseUrl}/${listId}/${crewId}/vhf`);
};

export const updateVhfDocuments = (listId: string, crewId: string, payload: UserDocumentsResponse): Promise<AxiosResponse<UserDocumentsResponse>> => {
  return apiClient.put(`${baseUrl}/${listId}/${crewId}/vhf`, payload);
};

export const deleteVhfDocument = (listId: string, crewId: string, uuid: string): Promise<AxiosResponse> => {
  return apiClient.delete(`${baseUrl}/${listId}/${crewId}/vhf/${uuid}`);
};
